var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewChatBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4731_19469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.172 38.5782L73.9219 12.3282C73.2075 11.6317 72.2477 11.2444 71.25 11.2501H26.25C24.2609 11.2501 22.3532 12.0402 20.9467 13.4468C19.5402 14.8533 18.75 16.7609 18.75 18.7501V101.25C18.75 103.239 19.5402 105.147 20.9467 106.553C22.3532 107.96 24.2609 108.75 26.25 108.75H93.75C95.7391 108.75 97.6468 107.96 99.0533 106.553C100.46 105.147 101.25 103.239 101.25 101.25V41.2501C101.256 40.2524 100.868 39.2926 100.172 38.5782ZM71.25 41.2501V20.6251L91.875 41.2501H71.25Z",
    fill: "#5B61EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4731_19469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChatBig);
export default __webpack_public_path__ + "static/media/new-chat-big.687bea6a094fb633c8451cbc9ab33831.svg";
export { ForwardRef as ReactComponent };